import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useCreateTeam } from "../../entities/api";
import { useHttp } from "~hooks/useHttp.js";
import AddAndEditTeamModal from "./AddAndEditTeamModal";
import { useNotification } from "~hooks/useNotification";

const AddTeam = (props) => {
  const { isModalOpen, handleClose, entityTarget = "organization", refetch, onAdd } = props;
  const { formatMessage } = useIntl();
  const { loading, request, error, cleanError } = useHttp();
  const { organizationId, sport, seasonId } = useParams();
  const { mutateAsync: createFn, isPending: isCreatePending } = useCreateTeam();
  const notification = useNotification();

  const handleSendRequest = async (form) => {
    try {
      let entityUrl = `/v1/${sport}/o/${organizationId}/entities`;
      if (entityTarget === "season") {
        entityUrl = `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/entities`;
      }

      const data = await form.validateFields();

      data.colors = {
        primary: data?.primary || null,
        secondary: data?.secondary || null,
        tertiary: data?.tertiary || null,
      };
      delete data.primary;
      delete data.secondary;
      delete data.tertiary;

      if (entityTarget === "organization") {
        const res = await createFn({
          ...data,
        });
        onAdd?.(res?.data?.[0]);
        handleClose();
        return;
      }

      const res = await request({
        url: entityUrl,
        method: "POST",
        body: {
          ...data,
        },
      });

      if (res?.data?.length) {
        if (refetch) {
          refetch();
        }
        notification.success({
          message: formatMessage({
            id: "team.add.success",
            defaultMessage: "Team added successfully",
          }),
          placement: "bottomRight",
        });
        handleClose();
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (error) {
      notification.error({
        message: formatMessage({
          id: "team.add.failed",
          defaultMessage: "Add Team has failed",
        }),
        placement: "bottomRight",
      });
      cleanError();
    }
  }, [cleanError, error]);

  return (
    <AddAndEditTeamModal
      {...props}
      entityTarget={entityTarget}
      openModal={isModalOpen}
      handleCloseModal={handleClose}
      handleSendRequest={handleSendRequest}
      okButtonLoading={loading || isCreatePending}
    />
  );
};

export default AddTeam;
